module.exports = __webpack_public_path__ + "images/anhui_banner02.jpg?bd756e7783089bb36e56051c8fc76afa";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/anhui_banner02.jpg
// module id = 167
// module chunks = 1